import Rest from 'services/data/rest';
import _ from 'lodash';

// Actions
import { alerts } from 'modules/alerts/actions';
import * as pageData from 'modules/page-data/actions';

// Services
import * as socket from 'services/socket';


export default class Team extends Rest {
  static path = 'Team';
  static defaultQuery = {
    load: [
      'members',
      'members.primaryEmail'
    ],
    sort: 'order'
  };

  static initializeSocket() {
    Team.loadTeams();

    socket.registerSocket('team', Team.loadTeams, Team.loadTeams);
  }

  static loadTeams() {
    Team.find(Team.defaultQuery)
      .then((teams) => {
        pageData.update('teams', teams);
      })
      .catch(alerts.catchError);
  }

  static getTeamEmails(currentUser, teams) {
    const teamId = _.get(currentUser, 'team.id');

    if (!teamId) return '';

    const team = _.find(teams, { id: teamId }) || {};
    const teamMembers = _.reject(team.members, { id: currentUser.id });
    const teamMemberEmails = _.map(teamMembers, 'primaryEmail.email');
    return _.join(teamMemberEmails, ',');
  }
}



// WEBPACK FOOTER //
// ./app/services/data/team.js